const ACCOUNT_STATS_LOAD_BY_ACCOUNT = "account-stats::load::by-account";
const ACCOUNT_STATS_LOAD_BY_ACCOUNT_FAILURE =
  "account-stats::load::by-account::failure";
const ACCOUNT_STATS_LOAD_BY_ACCOUNT_SUCCESS =
  "account-stats::load::by-account::success";
const ACCOUNT_STATS_LOAD_BY_DATE = "account-stats::load::by-date";
const ACCOUNT_STATS_LOAD_BY_DATE_FAILURE =
  "account-stats::load::by-date::failure";
const ACCOUNT_STATS_LOAD_BY_DATE_SUCCESS =
  "account-stats::load::by-date::success";
const UNLOAD_ACCOUNT_STATS = "account-stats::unload";

const unloadAccountStatsAction = {
  type: UNLOAD_ACCOUNT_STATS,
};

export {
  ACCOUNT_STATS_LOAD_BY_ACCOUNT,
  ACCOUNT_STATS_LOAD_BY_ACCOUNT_FAILURE,
  ACCOUNT_STATS_LOAD_BY_ACCOUNT_SUCCESS,
  ACCOUNT_STATS_LOAD_BY_DATE,
  ACCOUNT_STATS_LOAD_BY_DATE_FAILURE,
  ACCOUNT_STATS_LOAD_BY_DATE_SUCCESS,
  UNLOAD_ACCOUNT_STATS,
  unloadAccountStatsAction,
};
